import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const singIn = createAsyncThunk(
  "client/signin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}auth/api/v1/login`,
        data,
        {
          withCredentials: true, // Required for cross-origin cookie authentication
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response) {
        return rejectWithValue({
          message: error.response.data?.message || "Login failed",
          data: error.response.data || {},
          status: error.response.status
        });
      }
      return rejectWithValue({
        message: error.message || "Login failed",
        data: {}
      });
    }
  }
);


export const fetchUserData = createAsyncThunk(
  "webuser/profile", 
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        return rejectWithValue("No authentication token found");
      }

      const response = await axios.get(
        `${baseUrl}webuser/api/v1/profile`,
        {
          withCredentials: true, // Required for cross-origin cookie authentication
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      
      console.log("fetchUserData",response);
      return response;
    } catch (error) {
      console.error("Fetch user data error:", error);
      return rejectWithValue(
        error.response?.data?.message || 
        error.response?.data?.error || 
        "Failed to fetch user data"
      );
    }
  }
);
